import gql from 'graphql-tag';

import SuggestedWorkspaceFragment from '../../../fragments/SuggestedWorkspaceFragment.graphql';

export default gql`
  query GetSuggestedWorkspaceBanner {
    result: getSuggestedWorkspaceForCurrentUser {
      __typename
      ... on JoinableWorkspace {
        ...SuggestedWorkspaceFragment
      }
    }
  }
  ${SuggestedWorkspaceFragment}
`;
